export default "__VITE_ASSET__BqhK9il1__"